import { render, staticRenderFns } from "./EventsDescription.vue?vue&type=template&id=08e8ac9a&scoped=true&"
import script from "./EventsDescription.vue?vue&type=script&lang=js&"
export * from "./EventsDescription.vue?vue&type=script&lang=js&"
import style0 from "./EventsDescription.vue?vue&type=style&index=0&id=08e8ac9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8ac9a",
  null
  
)

export default component.exports